import { useCallback, useState } from "react";
import ApiKeysTable from "./ApiKeysTable";
import AppButton from "../AppButton";
import CreateKeyModal from "./CreateKeyModal";
import AppContentTitles from "../AppContentTitles";
import "./ApiKeys.css";

export const ApiKeys = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [shouldRefetch, setShouldRefetch] = useState(false);

  const triggerRefetch = useCallback(() => {
    setShouldRefetch((prev) => !prev);
  }, []);

  return (
    <div className="main-container">
      <AppContentTitles
        title="API Keys"
        description="View and manage all your API keys by app and platform. Check their status and make sure everything is running smoothly."
        children={
          hasData && (
            <div className="api-keys_button">
              <AppButton
                variant="secondary"
                onClick={() => setIsModalOpen(true)}
              >
                Add Platform
              </AppButton>
            </div>
          )
        }
      />
      <ApiKeysTable
        setHasData={setHasData}
        shouldRefetch={shouldRefetch}
        onPlatformCreate={triggerRefetch}
        onPlatformDelete={triggerRefetch}
        onRequestProduction={triggerRefetch}
      />
      <CreateKeyModal
        isVisible={isModalOpen}
        setIsModalVisible={setIsModalOpen}
        onKeyCreated={triggerRefetch}
      />
    </div>
  );
};

export default ApiKeys;
